import { Map } from 'immutable';

import Api from '../api';

import DonationMatchingRule from './model';
import { addAction, addMultipleAction, updateAction, removeAction } from './actions';

export default class DonationMatchingRulesApi {
  static fetchAll() {
    return Api.get<unknown[]>('api/donationMatchingRules').map((donationMatchingRules: unknown[]) =>
      addMultipleAction(
        Map<string, DonationMatchingRule>(
          donationMatchingRules.map((donationMatchingRule: unknown) => [
            donationMatchingRule.id,
            new DonationMatchingRule(donationMatchingRule),
          ])
        )
      )
    );
  }

  static fetch(id: string) {
    return Api.get(`api/donationMatchingRules/${id}`).map((donationMatchingRule) =>
      addAction(new DonationMatchingRule(donationMatchingRule))
    );
  }

  static create(data: unknown) {
    return Api.post('api/donationMatchingRules', data).map((donationMatchingRule) =>
      addAction(new DonationMatchingRule(donationMatchingRule))
    );
  }

  static update(id: string, data: unknown) {
    return Api.patch(`api/donationMatchingRules/${id}`, data).map((donationMatchingRule) =>
      updateAction(new DonationMatchingRule(donationMatchingRule))
    );
  }

  static delete(id: string) {
    return Api.delete(`api/donationMatchingRules/${id}`).map(() => removeAction(id));
  }
}
